import axiosClient from "../api/axiosClient";

/**
 * Notification center REST calls — ported from the mobile app's
 * src/services/api/index.js notification functions. Uses only the "real"
 * receiver-based endpoints on NotificationController; deliberately avoids
 * the parallel legacy endpoints (MarkAsRead, MarkAllNotificationsAsRead,
 * GetUnreadNotifications) which are [AllowAnonymous] and operate on a
 * different, effectively dead Notification.Status field instead of the
 * per-user NotificationReceiver row this panel (and the mobile app) reads.
 */

export const getNotifications = ({ pageNumber = 1, pageSize = 20, categoryIds } = {}) =>
  axiosClient.get("/Notification/User", { params: { pageNumber, pageSize, categoryIds } });

export const getUnreadCount = () => axiosClient.get("/Notification/User/SeenCount");

export const getNotificationCategories = () => axiosClient.get("/Notification/Categories");

export const markNotificationRead = (notificationReceiverId) =>
  axiosClient.put(`/Notification/MarkRead/${notificationReceiverId}`);

export const deleteNotification = (id) => axiosClient.delete(`/Notification/DeleteNotification/${id}`);

/** Despite the name, this backend endpoint marks everything read — it does not delete. */
export const markAllNotificationsRead = () => axiosClient.delete("/Notification/ClearAll");

export const deleteAllNotifications = () => axiosClient.delete("/Notification/DeleteAll");

export const clearNotificationsByCategory = (categoryIds, eventId) =>
  axiosClient.delete("/Notification/ClearByCategory", { data: { CategoryIds: categoryIds, EventId: eventId ?? null } });
